import { generatePath, Navigate } from "react-router-dom";
import { REQUEST_COMPENSATORY_TIME_OFF_EDIT_PATH } from "@/modules/requests/pages/compensatory-time-off-request";

export function OpenCompensatoryTimeOffRequest() {
  return (
    <Navigate
      to={generatePath(REQUEST_COMPENSATORY_TIME_OFF_EDIT_PATH, {
        id: new URL(window.location.href).searchParams.get("id"),
      })}
    />
  );
}
